export default __webpack_public_path__ + "static/media/Stonewall-Gray-Moss-Charcoal.da9b1e47.jpg";